import { useCallback } from 'react'
import sanitizeHtml, { IOptions } from 'sanitize-html'

export default function useSanitize(options?: IOptions) {
  const sanitize = useCallback(
    (value: string) => sanitizeHtml(value, options || { disallowedTagsMode: 'recursiveEscape' }),
    [options]
  )

  return sanitize
}
